import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const streamHeaderActions = style([
  {
    display: 'grid',
    gap: space.s8,
    alignItems: 'center',
  },
  responsiveStyle({
    mobile: {
      gridTemplateAreas: `
        "create-stream create-stream"
        "request-stream actions"
      `,
      gridTemplateColumns: '1fr auto',
      marginLeft: 0,
      width: '100%',
    },
    tablet: {
      gridTemplateAreas: `
        "request-stream create-stream actions"
      `,
      gridTemplateColumns: 'auto auto auto',
      marginLeft: space.s20,
      width: 'auto',
    },
  }),
]);

export const createStreamButton = style([
  {
    gridArea: 'create-stream',
    whiteSpace: 'nowrap',
  },
]);

export const requestStreamButton = style([
  {
    gridArea: 'request-stream',
    whiteSpace: 'nowrap',
  },
]);

export const actionsButton = style([
  {
    gridArea: 'actions',
  },
]);
